var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { usePhoneView } from "@michelin/acid-components";
import { useTranslation } from "@michelin/central-provider";
import DataSource from "devextreme/data/data_source";
import React, { useEffect, useState } from "react";
import { getChangeHistory } from "./getChangeHistory";
export const getDataSourceFactory = (options) => {
    const { buildQueryParams, } = options;
    const getDataSource = (params) => {
        const { api, app, authResultToken, entity, identifier, except, filters, ignore, } = params;
        let currentResults = -1;
        let updateResultsCounter = null;
        const dataSource = new DataSource({
            load(loadOptions) {
                return __awaiter(this, void 0, void 0, function* () {
                    let query = '';
                    if (loadOptions.filter) {
                        if (loadOptions.filter.filterValue) {
                            query = loadOptions.filter.filterValue;
                        }
                        else if (loadOptions.filter.length && loadOptions.filter[0].filterValue) {
                            query = loadOptions.filter[0].filterValue;
                        }
                    }
                    const queryParams = buildQueryParams({
                        application: app,
                        except,
                        identifier,
                        query,
                        filters,
                        skip: loadOptions.skip,
                        limit: loadOptions.take,
                        entity,
                    });
                    const resp = yield getChangeHistory({
                        api,
                        authResultToken,
                        except,
                        queryParams,
                    });
                    if (resp.Message)
                        throw Error(resp.Message);
                    if (resp.total === undefined)
                        return null;
                    currentResults = resp.total;
                    if (updateResultsCounter)
                        updateResultsCounter(currentResults);
                    return resp.data;
                });
            },
            totalCount() {
                return __awaiter(this, void 0, void 0, function* () {
                    return currentResults;
                });
            },
        });
        return {
            dataSource,
            renderResultsCounter: () => {
                function ResultsCounter() {
                    const { t } = useTranslation();
                    const [resultsCount, setResultsCount] = useState(currentResults);
                    const phoneView = usePhoneView();
                    useEffect(() => {
                        updateResultsCounter = setResultsCount;
                        return () => {
                            updateResultsCounter = null;
                        };
                    }, [setResultsCount]);
                    if (resultsCount === -1)
                        return React.createElement("i", null, t('Loading...'));
                    return (React.createElement("i", null, t(`${phoneView ? '{{resultsCount}} records' : 'Listing {{resultsCount}} records'}`, { resultsCount: resultsCount < 10000 ? resultsCount : '10000+' })));
                }
                return (React.createElement(ResultsCounter, null));
            },
        };
    };
    return getDataSource;
};
//# sourceMappingURL=getDataSource.js.map